import Actions from 'actions';

const initialState = Object.freeze([]);

function getTypes(state = initialState, action) {
  switch (action.type) {
    case Actions.FETCH_MEMBER_TYPES_REQUEST:
      return initialState;
    case Actions.FETCH_MEMBER_TYPES_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.FETCH_MEMBER_TYPES_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default getTypes;
